import Button from '@components/formControls/Button'
import { Theme, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const BreadCrumbButtonListContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
  }
`

export const BreadcrumItemButton = styled(Button)<{ $isActive?: boolean }>`
  height: 30px;
  box-shadow: 0 1px 4px 0 #1a1a431a;
  background: ${colors.white};
  color: ${colors.black};
  align-self: flex-start;
  margin-right: 0px;
  font-weight: 400;

  &:hover {
    background: ${colors.lightGrey};
  }

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    min-width: unset;
  }

  ${props =>
    props.$isActive
      ? `
          border: 1px solid ${colors.primary};
          pointer-events: none;
          cursor: default;

          &:hover {
            background: ${colors.white};
          }
        `
      : ''}
`
